import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Base/Grid/LostGrid.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Base.Grid.LostGrid';
export {styles};